'use client'

import { clickEvent, inboxConversationClickEvent } from '_libs/common/event-tracker/events'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { BrazeListItem } from '@marketplace-web/shared/braze'
import {
  useConversationContext,
  useConversationSidebarContext,
} from '@marketplace-web/domain/core-conversation'
import { ConversationListItemType } from '@marketplace-web/domain/conversation-messaging-data'

import { ClickableElement } from 'constants/tracking/clickable-elements'

import InboxListItem from '../InboxListItem'
import { isBrazeConversation } from '../../utils'

type Props = {
  conversation: ConversationListItemType
}

const ConversationListItem = ({ conversation }: Props) => {
  const { track } = useTracking()
  const { closeSidebar } = useConversationSidebarContext()
  const { conversation: activeConversation, setConversation } = useConversationContext()

  function handleClick() {
    if (isBrazeConversation(conversation)) {
      track(clickEvent({ target: ClickableElement.MessageReply }))

      return
    }

    track(
      inboxConversationClickEvent({
        conversationId: conversation.id,
        lastMessageId: conversation.last_message_id,
        pendingOfferRequestId: conversation.pending_offer_request?.offer_request_id || null,
        isOfferRequestLastMessage: conversation.pending_offer_request?.is_last_message || false,
      }),
    )
  }

  if (isBrazeConversation(conversation)) {
    return (
      <BrazeListItem
        card={conversation}
        onClick={handleClick}
        onCloseSidebar={closeSidebar}
        onSetConversation={setConversation}
        activeConversation={activeConversation}
      />
    )
  }

  return <InboxListItem conversation={conversation} onClick={handleClick} />
}

export default ConversationListItem
